import store from '../../store';

export default class WhatsAppOnHoldEvent {
  constructor(body) {
    window.console.log(
      '[WhatsAppOnHoldEvent]',
      JSON.parse(JSON.stringify(body)),
    );
    store.dispatch('channel/updateWhatsAppsOnHold', body.whatsAppsOnHold);
  }
}
